// extracted by mini-css-extract-plugin
export default {"zameenTopBannerAppShell":"index_zameenTopBannerAppShell__liL3n","zameenTopBanner":"index_zameenTopBanner__poH2X"};